import React from 'react'
import Header from '../components/Header'
import AboutSection from '../components/AboutSection'
import TestimonialsVideos from '../components/TestimonialsVideos'
import Footer from '../components/Footer'
import ProductsBanner from '../components/ProductsBanner'
import WhatsAppFloatingButton from '../components/WhatsAppFloatingButton'
import MissionInfographic from '../components/MissionInfographic'
import AboutCoreValues from '../components/AboutCoreValues'
import { Helmet } from "react-helmet";
const About = () => {


  const aboutData = {
    title: "About Dr Check",
    description:<>Dr.Chek is a pioneering quality healthcare technology brand dedicated to revolutionizing chronic disease management. By harnessing the power of advanced biosensing technology, we develop, manufacture, and distribute a comprehensive portfolio of point-of-care diagnostic test products.<br></br> <br></br>
    Designed for both individuals and healthcare professionals, our solutions deliver accurate and timely results for critical health indicators, including blood pressure, cholesterol, uric acid, hemoglobin, lipid profile, renal profile, and ketone levels, with a specific focus on diabetes. Beyond diagnostic tools, Dr.Chek provides a sophisticated suite of digital health management solutions, enabling seamless data tracking, personalized insights, and proactive health interventions. We are committed to empowering individuals to actively manage their health, improve their quality of life, and foster a future of proactive and personalized healthcare.
    </>,
    buttonText: "Contact Us",
    "buttonLink":"/contact",
    imageUrl:
      "/images/Dr. Chek _building.jpg",
      stats: [
        { value: "1", label: "India's first home health care brand with inhouse manufacturing capability." },
        { value: "2", label: "State of the Art manufacturing facilities all set to create innovative products." },
        { value: "9+", label: "Innovative Home Health Care & Point of Care Devices being launched in one year." },
        { value: "18+", label: "Health Care focussed Channel Partners catering every corner of India." },
        { value: "15000+", label: "Happy users experiencing a new level of confidence in their well-being." },
      ],
    };


  return (
    <div>
      <Helmet>
  <title>About Us - DrChek | Smart Healthcare & Diagnosis Solutions</title>
  <meta
    name="description"
    content="Learn more about DrChek, a leader in innovative healthcare and diagnostic solutions, committed to improving medical check-ups through technology."
  />
  <meta
    name="keywords"
    content="About DrChek, Healthcare Company, Medical Innovation, Smart Health Solutions, Healthcare Technology"
  />
  <meta name="viewport" content="width=device-width, initial-scale=1" />
</Helmet>

      <Header/>
      <ProductsBanner
        title="About Us"
        backgroundImage="/images/dr-chek-banner-001.png"
        backgrond="cover"
        height="400px"
      />
       <AboutSection {...aboutData} />
       <MissionInfographic/>
       <AboutCoreValues/>
      {/* <TestimonialsVideos/> */}
      <Footer/>
      <WhatsAppFloatingButton/>
    </div>
  )
}

export default About